import Vue from 'vue';
export default Vue.extend({
    props: {
        tooltipContent: { type: String, required: true },
        tooltipContentIsHtml: { type: Boolean },
        qIconProps: { type: Object },
        qTooltipProps: { type: Object }
    },
    computed: {
        qTooltipPropsComputed() {
            return Object.assign({ color: 'grey', name: 'mdi-information-variant' }, this.qIconProps);
        }
    }
});
